module.exports = __webpack_public_path__ + "img/header-diamondJewelryExclusive.0cfcc10.jpg";